import { Icon } from '@dixa/lib-shared-habla';
import { UseFloatingMenuReturn } from 'articleEditor/hooks/useFloatingMenu';
import { basicBlockActions } from 'articleEditor/utils/actions';
import cx from 'classnames';
import { useEditableProps } from 'lib-knowledge-document-structure/plate/common';
import { useMemo } from 'react';
import { mergeRefs } from 'react-merge-refs';

import { SortableBlockWrapper } from '../baseBlock';
import s from '../baseBlock/block.module.scss';
import { EmbedBlockProps } from './embedBlock';

type EmbedBlockPlaceholderProps = EmbedBlockProps & {
  floatingLinkMenu: UseFloatingMenuReturn;
};

export default function EmbedBlockPlaceholder({
  attributes,
  element,
  floatingLinkMenu,
  children,
}: EmbedBlockPlaceholderProps): JSX.Element {
  const blockActions = useMemo(() => [...basicBlockActions], []);
  const { readOnly } = useEditableProps();
  if (readOnly) return <></>;

  return (
    <SortableBlockWrapper
      className={s['blockEmbedPlaceholder']}
      element={element}
      blockActions={blockActions}
    >
      <div
        {...floatingLinkMenu.floatingMenuGetReferenceProps({
          ...attributes,
          ref: mergeRefs([
            floatingLinkMenu.floatingResult.refs.setReference,
            attributes.ref,
          ]),
          className: cx(s['mediaUploadArea'], s['blockContent']),
          contentEditable: false,
          onClick: floatingLinkMenu.openFloatingMenu,
        })}
      >
        <Icon className={s['mediaUploadAreaIcon']} name="image" />
        <div className={s['mediaUploadAreaText']}>Embed...</div>
      </div>
      {children}
    </SortableBlockWrapper>
  );
}
